<template>
  <HorizontalBarChart chart-id="chart-organ-offers-received"
    :config="chartConfig"
    :results="chartResults"
    :loading="chartLoading"
    :error="chartError"
    :header="`Organ Offers Received`"
    :hasUnapprovedOffers="false"
    @previewReport="previewReport"
    @reloadChart="loadChartData(filters)"/>
</template>

<script lang="js">
import { EP } from "~/src/endpoints";
import { chartMixin } from "@/src/mixins/chartMixin.js";
import HorizontalBarChart from "@/src/components/shared/charts/HorizontalBarChart.vue";

export default {
  components: {
    HorizontalBarChart,
  },
  mixins: [chartMixin],

  props: ['organ_groups', 'transplant_centers'],

  data() {
    return {
      chartConfig: {
        xTitle: 'Total Offers Received',
        barColours: ['#F9D45C'],
        barHoverColours: ['#fbe395'],
        resultLabelField: 'organ_name',
        datasets: [
          {
            dataField: 'total_offers',
            label: 'Total Offers',
          }
        ]
      },
      filters: {},
      aro: false,
      transplanted: false,
    };
  },
  methods: {
    loadChartData(filterParameters) {
      this.filters = filterParameters || {};
      this.getChartResults(EP.external_analytics.chart_organ_offers_received, filterParameters);
    },
  },
}
</script>
